/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved
import PhoneIcon from '@material-ui/icons/Phone';
import { storeContext } from '../provider/Provider';
import GreenButton from '../../customUI/GreenButton';
import { leadsActions } from '../../store/leads-reducer';
import { formatPhoneNumber } from '../../functions';
import DefaultInput from '../../customUI/DefaultInput';
import BlueButton from '../../customUI/BlueButton';

import CallDetails from '../call-details/CallDetails';

const { REACT_APP_FLASK_API_URL } = process.env;

const MobileCallsCard = ({ row, rowNumber }) => {
  const { state, dispatch } = React.useContext(storeContext);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDetailDialog, setOpenDetailDialog] = React.useState(false);
  const [fullName, setFullName] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [currentCallId, setCurrentCallId] = React.useState('');
  const [currentCallNumber, setCurrentCallNumber] = React.useState('');
  const [fullView, setFullview] = React.useState(false);
  const useStyles = makeStyles(() => ({
    mobileCard: {
      background: 'white',
      borderRadius: '16px',
      padding: 15,
      margin: 10,
      border: '3px white solid',
    },
    flexLine: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0',
    },
    flexLineDefault: {
      display: 'flex',
      alignItems: 'center',
    },
  }));

  const history = useHistory()


  const handleClick = () => {
    setFullview(!fullView);
  };

  const updateRows = (page, perPage) => {
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}/${page}/${perPage}`
      )
      .then((res) => {
        dispatch({
          type: leadsActions.LEADS_SET_ALL,
          payload: {
            isFetching: false,
            totalCalls: res.data.total_count,
            calls: res.data.message,
          },
        });
      });
  };

  const handleConvertCall = () => {
    const leadBody = {
      email,
      fullName,
      message,
      phone: currentCallNumber,
      website: state.websiteSwitch.currentWebsite,
    };
    axios
      .post(
        `${REACT_APP_FLASK_API_URL}/v1/calls/convert-to-lead/${state.websiteSwitch.currentWebsite}/${currentCallId}`,
        leadBody
      )
      .then((res) => {
        if (res.data.success) {
          setOpenDialog(false);
          if (state.leads) {
            updateRows(state.leads.currentPage, state.leads.perPage);
          }
          setEmail('');
          setFullName('');
          setMessage('');
          setCurrentCallNumber('');
          setCurrentCallId('');
        }
      });
  };

  const handleDetailClick = () => {
    history.push({
      state: { detail: row }
    });
    setOpenDetailDialog(true);
  }
  const classes = useStyles();
  return (
    <>
      <div
        className={classes.mobileCard}
        key={row.caller_number_complete}
        onClick={handleClick}
        aria-label="default box"
      >
        {fullView ? (
          <>
            <div className={classes.flexLine}>
              {state.leads && <div style={{ width: '10%', userSelect: 'none' }}>
                {(rowNumber + 1) + (state.leads.currentPage * state.leads.perPage)}
              </div>}
              <div style={{ width: '20%', userSelect: 'none' }}>{`${new Date(
                row.called_at
              ).toLocaleString('en-US', { month: 'short' })} ${new Date(
                row.called_at
              ).getFullYear()}`}</div>
              <div style={{ display: 'flex', alignItems: 'center', width: '80%', userSelect: 'none' }}>
                <a href={`tel:${row.caller_number_complete.replace(/[^\\d]/g, '')}`}>
                  <PhoneIcon style={{ fontSize: 'small', marginRight: 5 }} />
                  {formatPhoneNumber(row.caller_number_complete)}
                </a>
                {row.transcription_available && 
                  <Typography style={{ cursor: 'pointer', color: '#00b4e0', paddingLeft: 15 }}
                    onClick={handleDetailClick}
                  >Details</Typography>
                }
              </div>
            </div>
            <div
              style={{ background: '#00B4E0', height: '1px', width: '100%', margin: '10px 0' }}
            />
            <div>
              <div style={{ width: '100%', userSelect: 'none' }}>Status: {row.status}</div>
              <div style={{ marginTop: 15, userSelect: 'none' }}>
                Duration: {new Date(row.duration * 1000).toISOString().substr(11, 8)}
              </div>
            </div>

            <div className={classes.flexLine}>
              <BlueButton
                aria-label="convert call to lead"
                onClick={() => {
                  setCurrentCallNumber(row.caller_number_complete);
                  setCurrentCallId(row.id);
                  setOpenDialog(true);
                }}
              >
                Add Lead
              </BlueButton>
            </div>
          </>
        ) : (
          <div className={classes.flexLineDefault}>
            {state.leads && <div style={{ width: '10%', userSelect: 'none' }}>
              {(rowNumber + 1) + (state.leads.currentPage * state.leads.perPage)}
            </div>}
            <div style={{ width: '20%', userSelect: 'none' }}>{`${new Date(
              row.called_at
            ).toLocaleString('en-US', { month: 'short' })} ${new Date(
              row.called_at
            ).getFullYear()}`}</div>
            <div style={{ display: 'flex', alignItems: 'center', width: '80%', userSelect: 'none' }}>
              <a href={`tel:${row.caller_number_complete.replace(/[^\\d]/g, '')}`}>
                <PhoneIcon style={{ fontSize: 'small', marginRight: 5 }} />
                {formatPhoneNumber(row.caller_number_complete)}
              </a>
              { row.transcription_available && 
                <Typography style={{ cursor: 'pointer', color: '#00b4e0', paddingLeft: 15 }}
                    onClick={handleDetailClick}
                  >Details</Typography>
              }
            </div>
          </div>
        )}
      </div>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setFullName('');
          setMessage('');
          setCurrentCallNumber('');
        }}
      >
        <DialogTitle>Convert {currentCallNumber} Call to Lead</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="full name"
            label="Contact's Full Name *"
            fullWidth
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="full name"
            label="Contact's Email *"
            fullWidth
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <DefaultInput
            style={{ marginTop: 10, width: '100%' }}
            rows={5}
            multiline
            label="Message"
            value={message}
            data-testid="details_test_id"
            type="text"
            onChange={(e) => {
              setMessage(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialog(false);
              setFullName('');
              setMessage('');
              setCurrentCallNumber('');
            }}
            style={{ color: '#58595B' }}
          >
            Cancel
          </Button>
          <GreenButton aria-label="submit convert" onClick={handleConvertCall}>
            Submit
          </GreenButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDetailDialog}
        maxWidth="xl"
        onClose={() => {
          setOpenDetailDialog(false);
        }}
      >
        <DialogContent style={{ minWidth: '90vw'}}>
          <CallDetails />
        </DialogContent>
        <DialogActions>
        <Box>
            <Button
              onClick={() => { setOpenDetailDialog(false) }}
              style={{ color: '#58595B' }}
            >
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MobileCallsCard;
